import { render, staticRenderFns } from "./AddSearchFamilyMember.vue?vue&type=template&id=10cb3e96&scoped=true&"
import script from "./AddSearchFamilyMember.vue?vue&type=script&lang=js&"
export * from "./AddSearchFamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./AddSearchFamilyMember.vue?vue&type=style&index=0&id=10cb3e96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb3e96",
  null
  
)

export default component.exports